import { inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs';

import { checkValidation, trimWhitespace } from '@modules/core/utils/form';
import { FormService } from '@modules/core/services';

export abstract class BaseForm {
  formService = inject(FormService);
  abstract form: FormGroup;

  protected constructor(private methodName: keyof FormService) {
    this.initForm(methodName);
  }

  public checkValidation(): void {
    checkValidation(this.form);
  }

  private initForm(methodName: keyof FormService): void {
    if (typeof this.formService[methodName] === 'function') {
      this.form = this.formService[methodName]();
      this.trimWhitespace();
    }
  }

  private trimWhitespace(): void {
    this.form.valueChanges.pipe(debounceTime(600), distinctUntilChanged()).subscribe(() => {
      trimWhitespace(this.form);
    });
  }
}
